// Modules
import axios from 'axios'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux';
import { setLoggedAcc } from 'Modules/authority';
import { useState, useEffect } from 'react';

// CSS
import '_Asset/css/Admin/Include/adHeader.css'

import seyfertLogo from '../../_Asset/img/seyfert_logo_w.svg'

// API
import { ApprListApi, MemLogoutApi, MemSessionReApi } from '_Route/Api'


const AdHeader = () => {

  // Use Hooks
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const location = useLocation()
  const path = location.pathname

  const isLoginAcc = useSelector(state => state.loggedAcc)
  const userName = useSelector(state => state.authorityAcc.name); // 로그인된 회원 이름
  const userRoles = useSelector(state => state.authorityAcc.roles); // 로그인된 회원 권한
  const userScore = useSelector(state => state.authorityAcc.access_score); // 로그인된 회원 권한 점수

  const authHost = process.env.REACT_APP_AUTH_HOST
  const authCenterHost = process.env.REACT_APP_AUTH_CENTER_HOST

  const sessionID = localStorage.getItem('memSessionID')
  const curDate = new Date(); // 현재 시간
  const curDay = 24 * 60 * 60 * 1000 // h * m * s * ms


  /*========================================================================
  * 새 검토/승인 요청 조회
  ========================================================================*/
  const [newData, setNewData] = useState([])
  const apprListAlarm = newData?.length === 0 ? false : true
  const newSpecLen = newData?.filter(key => key.approve_spec === userName)?.length
  const newAprvLen = newData?.length - newSpecLen

  useEffect(() => {
    axios({
      url: ApprListApi,
      method: 'GET',
      headers: {
        "Content-Type": "application/json",
        'Authorization': sessionID,
      },
    })
    .then(res => {
      // console.log(res, "GET Review Aprv List Success!")
      const r = res.data.result;
      const sumData = r.approve.concat(r.specifie)

      setNewData(sumData.filter(data => 
        parseInt((curDate - new Date(data.approve_req_date)) / curDay) < 1
      ))
    })
    .catch(err => {
      console.error("GET Review Aprv List ERROR...", err);
    })
  }, [location])


  /*========================================================================
  * 회원 로그아웃
  ========================================================================*/
  // Seyfert 인증센터 로그아웃
  const seyfertLogout = () => {
    axios({
      url: `${authHost}/logout`,
      method: 'POST'
    })
    .then(res => {
      // console.log(res, "Seyfert 인증센터 Logout Success!")
    })
    .catch(err => {
      console.log(err, "Seyfert 인증센터 Logout Error...")
    })
  }

  // Seyfert 개발자 포탈 로그아웃
  const logout = () => {
    axios.defaults.withCredentials = true;
    axios({
      url: MemLogoutApi,
      method: 'GET',
    })
    .then(res => {
      // console.log(res, "Member Logout Success!")
      seyfertLogout()
      dispatch(setLoggedAcc(false))
      localStorage.clear()
      alert("로그아웃을 완료하였습니다.")
      navigate('/member-login')
    })
    .catch(err => { 
      console.error(err, "Member Logout Error...")
    })
  } 

  const Logged = () => {
    if (isLoginAcc) {
      logout()
    } else {
      navigate('/member-login')
    }
  }

  /*========================================================================
  * 세션 시간 연장
  ========================================================================*/
  let myCount = localStorage.getItem('memSessionTime');
  const ReSssion = () => {
    axios({
      method: 'GET',
      url: MemSessionReApi,
    })
    .then(res => {
      // console.log(res, "Member Re Session Success!")
      localStorage.setItem('memSessionTime', res.data.retime * 60)
      myCount = res.data.retime * 60
    })
    .catch(err => { 
      console.error(err, "Member Re Session Error...")
    })
  } 
  

  /*========================================================================
  * 세션 타이머 / 타임 아웃 처리
  ========================================================================*/
  const [sessionTime, setSessionTime] = useState('');
  let seconds = 0;
  
  const myUseTime = () => {
    if(myCount) {
      myCount -= 1;
      localStorage.setItem("memSessionTime", myCount);
      seconds = myCount < 0 ? 0 : myCount;

      const hour = parseInt(seconds / 3600) < 10 ? '0'+ parseInt(seconds / 3600) : parseInt(seconds / 3600); 
      const min = parseInt((seconds % 3600) / 60) < 10 ? '0'+ parseInt((seconds % 3600) / 60) : parseInt((seconds % 3600) / 60); 
      const sec = seconds % 60 < 10 ? '0' + seconds % 60 : seconds % 60;
      const useTime = hour + ":" + min + ":" + sec;
      setSessionTime(useTime)

      if (myCount === 0) {
        dispatch(setLoggedAcc(false))
        localStorage.removeItem('memLoginKey')
        localStorage.removeItem('memSessionID')
        localStorage.removeItem('memSessionTime')

        if(path.split('/')[1] === 'admin') {
          alert("세션이 만료되었습니다. 다시 로그인을 시도해주세요.")
          navigate('/member-login');
        }
      }
    }
  }

  useEffect(() => {
    if(isLoginAcc && myCount !== null && myCount > 0){
      const time = setInterval(() => {
        myUseTime();
      }, 1000);
      return (() => clearInterval(time))
    }
  }, [isLoginAcc, myCount])


  return (
    <header className="admHeader">
      <div className="adInnerHdr">
        <Link to="/admin/km/list" className="sfrtLogo">
          <img src={seyfertLogo} alt="Seyfert"></img>
          <span>Developers Admin</span>
        </Link>
        
        <a href="/" target="_blank" title="새창에서 열림" className="btn transparent xs round_10">사용자 화면으로 돌아가기 <i className="icofont-arrow-right" /></a>
      </div>

      <div className="accArea">
        <div className="sessionGroup">
          <p>{sessionTime}</p>
          <button type="button" className="btn sfrtBlue xs round_10" onClick={ReSssion}>세션 갱신</button>
        </div>

        <div className="adProfile">
          <i className="icofont-ui-user"></i>
          {/* <a href={`${authCenterHost}/dashboard/profile`} target="_blank" title="Seyfert 인증센터로 이동">
            {userName} 님
          </a> */}
          <Link to="/admin/review-aprv/mgt" title="검토/승인 관리로 이동">{userName} 님</Link>

          <div className="msgBox top black">
            {apprListAlarm &&
              <>
                <h2>새 검토/승인 요청</h2>
                <p>
                  최근 하루간 새로운 검토/승인 요청이 있습니다.<br />
                  새 검토 요청 - <span>{newSpecLen}개</span><br />
                  새 승인 요청 - <span>{newAprvLen}개</span><br /><br />
                </p>
              </>
            }
            <h2>내 개발자 포탈 권한 정보</h2>
            <p>
              권한 (Roles): <span>{userRoles}</span><br />
              엑세스 스코어 (Access Score): <span>{userScore}</span>
            </p>
          </div>
          {apprListAlarm && <span>{newData.length}</span> }
        </div>

        <a href={`${authCenterHost}/dashboard/profile`} target="_blank" title="Seyfert 인증센터로 이동">
          내정보
        </a>

        <button type="button" onClick={Logged}>{isLoginAcc ? '로그아웃' : '로그인'}</button>
      </div>
    </header>
  )
}

export default AdHeader;